import state from "../../data/stateActive.json";
import { useNavigate } from "react-router-dom";
import {
  ButtonSearchComponent,
  FilterComponent,
  InputSearchComponent,
} from "../../components";

export const ModifierSearchContainer = () => {
  const navigate = useNavigate();
  const filter = () => {
    const state = document.getElementById("stateModifier").value;
    const search = document.getElementById("searchModifier").value;

    let url = `/productos/modificadores?`;
    if (state !== "null") {
      url = url.concat(`active=${state}`);
    }
    if (search !== "null") {
      url = url.concat(`&search=${search}`);
    }
    navigate(url);
  };
  const dataInput = { id: "searchModifier", placeholder: "Buscar Modificador" };
  const handleEnter = (e) => {
    if (e.key !== "Enter") return;
    filter();
  };
  return (
    <div className="modifierSearchContainer">
      <div className="modifierSearchContainer__filters">
        <div className="modifierSearchContainer__filters__item">
          <FilterComponent data={state} name={"Estado"} id={"stateModifier"} />
        </div>
      </div>
      <div className="modifierSearchContainer__search">
        <div className="modifierSearchContainer__search__input">
          <InputSearchComponent data={dataInput} onKeyDown={handleEnter} />
        </div>
        <div className="modifierSearchContainer__search__button">
          <ButtonSearchComponent filter={filter} />
        </div>
      </div>
    </div>
  );
};
